const postcodeInit = () => {
  window.dataLayer = window.dataLayer || [];
  const postcodeCheckers = document.getElementsByClassName(
    'postcode-form',
  );
  [...postcodeCheckers].forEach((postcodeChecker: HTMLFormElement) => {
    postcodeChecker.addEventListener('submit', (e) => {
      e.preventDefault();
      const form = e.target as HTMLElement;
      const page = form.getAttribute('action');
      const postField = form.querySelector(
        'input[name="postcode"]',
      ) as HTMLInputElement;
      const numberField = form.querySelector(
        'input[name="nummer"]',
      ) as HTMLInputElement;

      postField.classList.remove('error-border');
      numberField.classList.remove('error-border');

      const postcode = postField.value.replace(/\s/g, '').toUpperCase();
      const number = numberField.value.replace(/\s/g, '');

      if (postcode.match('[0-9]{4}?[a-zA-Z]{2}') && number.match('[0-9]{1,5}')) {
        let url = `${page}?postcode=${postcode}&nummer=${number}`;

        window.dataLayer.push({});

        window.dataLayer.push({
          event: 'Postcodecheck Website',
          eventCallback: () => {
            document.location = url;
          },
          eventTimeout: 500,
          ecommerce: {
            checkout: {
              actionField: {
                step: 1,
                option: 'Postcodecheck',
              },
            },
          },
        });

        postcodeChecker.submit();
      } else {
        if (!postcode.match('[0-9]{4}?[a-zA-Z]{2}')) {
          postField.classList.add('error-border');
        }
        if (!number.match('[0-9]{1,5}')) {
          numberField.classList.add('error-border');
        }
      }
    });
  });
};
export default postcodeInit;
